import './styles.scss';
import every from 'lodash/every';

const PhoneInput = () => import('../../components/phone-input/index.vue');

export default {
    name: 'ContactDetailPage',

    components: {
        'phone-input': PhoneInput
    },
    
    data() {
        return {
            editing: false,
            contact: {}
        }
    },
    
    computed: {
        stored_contact() {
            return this.$store.getters.getContact(this.$route.params.id);
        },

        types() {
            return this.$store.getters.getContactTypes;
        },

        list() {
            return this.$store.state.contacts.contacts_list;
        },

        readonly() {
            let readonly = !this.editing;
            return readonly.toString();
        },

        subscription() {
            return this.$store.getters.getActiveSubscription;
        },
        
        canEdit() { 
            return this.subscription.permissions.includes('ugc_create');
        }
    },

    watch: {
        stored_contact: 'onRoute',

        list() {
            this.$store.commit('setMenuItems', this.$store.getters.getContactsList);
        }
    },

    created() {
        this.$store.commit('setMenuItems', this.$store.getters.getContactsList);
        this.$store.commit('setMenuDetails', { title: 'Contacts', slug: 'contacts', back_url: '/action/operations' });
        
        this.onRoute();
    },

    methods: {
        onRoute() {
            if (this.stored_contact) {
                this.contact = this.stored_contact;

                this.contact.phone.forEach((phone, index) => {
                    phone.id = Math.random().toString(36).substring(7);
                    phone.valid = true;
                });
            }
        },

        save() {
            if (this.$store.state.online_status) {
                if (this.editing) {
                    this.submitUpdate();
                } else {
                    this.editing = true;
                }
            } else {
                this.$ionic.alertController.create({
                    message: 'Please establish and internet connection and try again.',
                    buttons:['OK']
                }).then(a => a.present());
            }
        },

        addPhone() {
            const phone = {
                phone_number: '',
                type: this.contact.phone.length + 1,
                id: Math.random().toString(36).substring(7)
            };

            this.contact.phone.push(phone);
        },

        deletePhone(index) {
            this.contact.phone.splice(index, 1);

            this.contact.phone.forEach((phone, index) => {
                phone.value = phone.phone_number;
                this.updatePhone(phone, index);
            });
        },

        updatePhone(event, index) {
            this.contact.phone[index].phone_number = event.value;
            this.contact.phone[index].valid = event.valid;
            this.contact.phone[index].type = index + 1;
        },

        submitUpdate() {
            let name = this.contact.name.length, phones = every(this.contact.phone, 'valid');
            
            console.info(phones);

            if (name && phones) {
                const ctx = {
                    id: this.contact.id,
                    content: this.contact
                };

                console.info(this.contact);

                this.$store.dispatch('updateContactDB', ctx).then((response) => {
                    this.editing = false;
                }).catch((error) => {
                    this.$ionic.alertController.create({
                        message: 'Unable to save changes.',
                        buttons:['OK']
                    }).then(a => a.present());
                });
            } else {
                console.error("Nothing to save.");
            }
        },

        deleteContact() {
            if (this.$store.state.online_status) {
                this.$ionic.alertController.create({
                    header: "Are you sure?",
                    message: "This action cannot be undone.",
                    buttons: [
                        {
                            text: 'Cancel',
                            role: 'cancel'
                        },
                        {
                            text: 'Delete Contact',
                            handler: () => {
                                if (this.$store.state.online_status) {
                                    this.$store.dispatch('deleteContactDB', this.contact.id).then((response) => {
                                        this.$router.push('/action/operations/contacts#back');
                                    }).catch((error) => {
                                        this.$ionic.alertController.create({
                                            message: 'Unable to delete contact.',
                                            buttons:['OK']
                                        }).then(a => a.present());
                                    });
                                } else {
                                    this.$ionic.alertController.create({
                                        message: 'Please establish and internet connection and try again.',
                                        buttons:['OK']
                                    }).then(a => a.present());
                                }
                            },
                        },
                    ],
                }).then(a => a.present());
            } else {
                this.$ionic.alertController.create({
                    message: 'Please establish and internet connection and try again.',
                    buttons:['OK']
                }).then(a => a.present());
            }
        }
    }
};